import {defaultPageSize} from "~/modules/catalog/category/composables/useFacet/perPageOptions";

export const customRemoveProductsFromWishlistQuery = `
  mutation removeProductsFromWishlist($id: ID!, $items: [ID!]!, $pageSize: Int = ${defaultPageSize}) {
    removeProductsFromWishlist(wishlistId: $id, wishlistItemsIds: $items) {
      wishlist {
        id
        items_count
        items_v2 (pageSize: $pageSize) {
          items {
            id
            product {
              uid
              __typename
              sku
            }
          }
          page_info {
            current_page
            page_size
            total_pages
          }
        }
      }
    }
  }
`;
